import request from '@/utils/request'
import { UserDefaultSetting } from '@/types/user'

export function Get(): Promise<UserDefaultSetting> {
  return request.get('/default')
}

// eslint-disable-next-line
export function CreateOrUpdate(data: UserDefaultSetting): Promise<string> {
  return request.patch('/default', data)
}
